module.exports = __webpack_public_path__ + "static/media/logo.6288ee49.jpg";